module.exports = __webpack_public_path__ + "media/lesson/fonts/Frutiger/FrutigerBold-5c1c111cb524e9fe2d0e91d19b1487a4.woff";